import { createSlice } from "@reduxjs/toolkit";

export const VendorSelectSlice = createSlice({
    name : 'vendorSelectSlice',
    initialState : {
        value:{} 
    },
    reducers : {
        updateVedorSelectSlice: (state, action) => {
            if(action.payload.type){
                return { ...state,
                    value:{
                      ...state.value,[action.payload.type]: action.payload.value
                    }              
                }
            }
            else{
              state.value = action.payload
            }
        }
    }
});

export const { updateVedorSelectSlice } = VendorSelectSlice.actions

export default VendorSelectSlice.reducer